export const FILE_INPUT_DATA_IDS = {
  base: 'fileField',
  title: 'title',
  textField: '',
  progress: 'progress',
  clearBtn: 'clear',
  attach: 'attach',
  hiddenInput: 'hiddenInput',
  endAdornment: 'endAdornment'
};
